var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5286 6.74722C11.7889 6.48687 11.7889 6.06476 11.5286 5.80441C11.2682 5.54406 10.8461 5.54406 10.5858 5.80441L7.5286 8.8616L4.4714 5.80441C4.21105 5.54406 3.78895 5.54406 3.52859 5.80441C3.26825 6.06476 3.26825 6.48687 3.5286 6.74722L7.5286 10.7472L11.5286 6.74722Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.63e14cbcc60936a5e9003634d9e07a15.svg";
export { ForwardRef as ReactComponent };